<template>
  <div class="page-settings-modal-wrapper fancy-scroll">
    <div class="close-btn-wrapper" @click="onClose"></div>

    <div class="setting-items-wrapper">
      <div
        class="switch-group row position-relative"
        v-for="marginOption in marginOptions"
        :key="marginOption.value"
      >
        <div class="col-9 pt-3 label-wrapper">
          <label class="caption">{{ marginOption.label }}</label>
        </div>
        <div class="col-3 switch-wrapper">
          <label name="required" class="switch class pull-right">
            <input
              type="radio"
              :checked="marginOption.value == task.props.margin"
              name="width"
              @change="() => onSelectPageMargin(marginOption)"
              :disabled="!isUserHasAccess"
            />
            <span class="slider round" :disabled="!isUserHasAccess"></span>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageBuilderSettings',
  data() {
    return {
      marginOptions: [
        {
          label: 'Keine Marge',
          value: 'no-margin',
        },
        {
          label: 'Kleiner Spielraum',
          value: 'small-margin',
        },
        {
          label: 'Großer Spielraum',
          value: 'large-margin',
        },
      ],
    };
  },
  props: {
    task: {
      type: Object,
      required: true,
      default: () => {},
    },
    isUserHasAccess: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  mounted() {
    if (!this.task?.props?.margin) {
      this.$set(this.task.props, 'margin', 'small-margin');
    }
  },
  methods: {
    onClose() {
      this.$emit('onClose');
    },
    onSelectPageMargin(selectedMargin) {
      this.task.props.margin = selectedMargin.value;
    },
  },
};
</script>

<style scoped>
.page-settings-modal-wrapper {
  width: 425px;
  border-left: 1px solid rgb(222, 227, 233);
  background-color: #ffffff;
  border-radius: 0px 19px 19px 0px;
  height: 100%;
  position: relative;
}
.page-settings-modal-wrapper .close-btn-wrapper {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 1;
  background-image: url(/img/modal-sprite.67649c98.png);
  background-size: 1293px 1277px;
  background-position: -1278px -577px;
  cursor: pointer;
  border-radius: unset;
  box-shadow: none;
  width: 15px;
  height: 15px;
  padding: 0;
}
.page-settings-modal-wrapper .close-btn-wrapper:hover {
  opacity: 0.8;
}

.page-settings-modal-wrapper .setting-items-wrapper {
  padding: 38px;
}

.page-settings-modal-wrapper .switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.page-settings-modal-wrapper .switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.page-settings-modal-wrapper .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.page-settings-modal-wrapper .slider:before {
  position: absolute;
  content: '';
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.page-settings-modal-wrapper input:checked + .slider {
  background-color: #000;
}

.page-settings-modal-wrapper input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.page-settings-modal-wrapper .slider.round {
  border-radius: 34px;
}

.page-settings-modal-wrapper .slider.round:before {
  border-radius: 50%;
}
.page-settings-modal-wrapper label {
  display: block;
  padding-top: 0;
  padding-bottom: 9px;
  margin-right: 10px;
  margin-bottom: 0px;
  font-size: 13px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
}
.page-settings-modal-wrapper .switch-wrapper {
  margin-top: 5px;
}
.page-settings-modal-wrapper .switch-group .label-wrapper {
  text-align: left;
}
[disabled] {
  opacity: 0.5;
  cursor: not-allowed !important;
}
</style>
